<template>
  <div>
    <div v-if="isAddNewAnswerShown"
         class="flex items-center cursor-pointer hover:bg-primary-light py-2"
    >
      <vs-icon icon="add" color="primary" class="p-1 border-solid border rounded border-primary"/>
      <span class="text-primary font-semibold ml-3">New Answer:</span>
      <span class="ml-1">{{ query }}</span>
    </div>

    <div v-else class="flex flex-col leading-none">
      <div class="text-base font-medium w-full"
           :class="active ? 'text-primary-dark' : 'text-gray-dark'">
        {{ answer && answer.name }}
      </div>

      <span v-if="displayExample" class="text-sm italic mt-2 clamp-5" :class="secondaryClasses">
        "{{ answer && answer.intent && answer.intent.example }}"
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AnswerSelectOption',
  props: {
    answer: {
      type: Object,
      default: () => {}
    },
    active: {
      type: Boolean
    },
    displayExample: {
      type: Boolean,
      default: false
    },
    isHighlighted: {
      type: Boolean,
      default: false
    },
    isAddNewAnswerShown: {
      type: Boolean,
      default: false
    },
    query: {
      type: String,
      default: ''
    }
  },
  computed: {
    secondaryClasses() {
      return this.active ? 'text-primary-dark-accent' : 'text-gray-dark'
    }
  }
}
</script>
